import REPORT from './Report';

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/Inbound/components/index.js